<!-- eslint-disable prettier/prettier -->
<template>
  <!-- <div class="home" style="background-image: url(@assets/hero.jpg)"> -->
  <!-- <div class="flex flex-col items-center justify-center w-full home"> -->
  <div class="flex flex-col items-center justify-center w-full home" id="home">
    <h1 class="py-6 text-3xl text-white">
      Bienvenue dans la  <span class="font-bold primary">Communauté FreeTalk</span>
    </h1>
    <h2 class="w-1/2 py-4 text-6xl font-bold text-white">
      Avec FreeTalk, la liberté d’expression est notre priorité
    </h2>
    <hr class="w-1/3 h-3 mb-4 primary" />
    <p class="w-1/2 py-4 text-xl text-white">
      FreeTalk est une plateforme interactive en ligne qui facilite la communication libre entre utilisateurs du monde entier. Elle propose des forums, des salles de chat en temps réel et des blogs pour échanger des idées et débattre. Son interface conviviale encourage les échanges interculturels et aide à améliorer les compétences en communication. En mettant l'accent sur la diversité et l'inclusion, FreeTalk crée un environnement respectueux où toutes les voix peuvent s'exprimer, soutenues par des modérateurs actifs.
    </p>
    <div class="flex mt-4">
      
      <button
      @click="$router.push('signup')"
        class="text-white bg-primary focus:ring-4 font-medium rounded-lg text-xl px-16 py-3.5 me-2 mb-2 mr-8"
      >
       S'enregistrer
      </button>
      <button
      @click="$router.push('signin')"

        class="text-black bg-white focus:ring-4 font-medium rounded-lg text-xl px-16 py-3.5 me-2 mb-2"
      >
        
       Se connecter

      </button>
    </div>
  </div>
</template>

<style>
.home {
  background: url("../../../assets/hero.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 87.5vh;
}
/* body {
  background: url("../../public/images/hero.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
} */
</style>

<script>
// @ is an alias to /src
export default {
  name: "HomeView",
};
</script>
